import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'template'

  // List of all fields (schema) of the template model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      name: this.string(''),
      slug: this.string(''),
      type: this.string(''),
      extra: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/api/spawner',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/templates',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/templates/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/templates',
          method: 'template',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/templates/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/templates/:id',
          method: 'delete',
        },
      },
    },
  }
}
